var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvoiceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0034 9.99916V4.99708C20.0034 3.89205 19.1076 2.99625 18.0026 2.99625H4.99717C3.89214 2.99625 2.99634 3.89205 2.99634 4.99708V19.0029C2.99634 20.1079 3.89214 21.0037 4.99717 21.0037H9.99925",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.24908 15.0012H9.99939",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.24902 10.9996H14.001",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.24902 7.12295H16.0018",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.12277 15.1263C6.19183 15.1263 6.24782 15.0703 6.24782 15.0012C6.24782 14.9322 6.19183 14.8762 6.12277 14.8762C6.0537 14.8762 5.99771 14.9322 5.99771 15.0012C5.99771 15.0703 6.0537 15.1263 6.12277 15.1263",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.12277 11.1246C6.19183 11.1246 6.24782 11.0686 6.24782 10.9996C6.24782 10.9305 6.19183 10.8745 6.12277 10.8745C6.0537 10.8745 5.99771 10.9305 5.99771 10.9996C5.99771 11.0686 6.0537 11.1246 6.12277 11.1246",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.12277 7.248C6.19183 7.248 6.24782 7.19201 6.24782 7.12295C6.24782 7.05389 6.19183 6.9979 6.12277 6.9979C6.0537 6.9979 5.99771 7.05389 5.99771 7.12295C5.99771 7.19201 6.0537 7.248 6.12277 7.248",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5024 13.0004C19.9887 13.0004 22.0042 15.016 22.0042 17.5023C22.0042 19.9886 19.9887 22.0042 17.5024 22.0042C15.016 22.0042 13.0005 19.9886 13.0005 17.5023C13.0005 15.016 15.016 13.0004 17.5024 13.0004",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0591 16.725L17.1143 18.6698L15.9458 17.5023",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoiceIcon);
export default __webpack_public_path__ + "static/media/invoiceIcon.7869297126e34749741f2ee16ed1ab3c.svg";
export { ForwardRef as ReactComponent };